import { Injectable } from '@angular/core';
import { Headers, Request, Response, RequestMethod, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';
import { PermissionDc, RolePermissionDc } from '../security/permission.dc';
import { SessionHelper } from '../common/helpers/session.helper';
import { Router } from '@angular/router';
import { UserTypeConstant } from './user-type.constant';
import { CustomerPortalAcessEnum } from './customer-portal-acess.enum';
import { HttpHelper } from '../common/helpers/http.helper';
import { ModuleAccessPermission } from './../crm/models/module-access-permission.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as CryptoJS from 'crypto-js';


@Injectable()
export class PermissionService {
    private rolePermission: RolePermissionDc;
    private encryptSecretKey = "A<K9A>@HNS^Mjfu";
    public moduleAccessPermission = new ModuleAccessPermission();

    private urlSource = new BehaviorSubject<string>('');
    currentURL = this.urlSource.asObservable();

    previousURL: string = '';

    constructor(
        private router: Router,
        private _httpHelper: HttpHelper
    ) {

    }

    init(perms: RolePermissionDc) {
        this.rolePermission = perms;
    }

    public getRolePermission(userType: string): RolePermissionDc {
        if (this.rolePermission == undefined) {
            let sessionUserType = SessionHelper.getUserType();
            const customerSession = SessionHelper.getCustomerSession();
            if (sessionUserType) {
                userType = sessionUserType;
            }
            else if (customerSession && customerSession.userType) {
                userType = customerSession.userType;
            }
            this.setPermission(userType);
        }
        return this.rolePermission;
    }

    public getPermissionByScreenId(screenId: number): PermissionDc {
        return this.rolePermission.PermissionDcs.filter(x => x.ScreenId == screenId)[0];
    }


    public async getPermissionByScreenIdAsync(screenId: number, userType: string): Promise<PermissionDc> {
        if (this.rolePermission.PermissionDcs.length <= 0) {
            await this.setPermission(userType);
        }
        return this.rolePermission.PermissionDcs.filter(x => x.ScreenId == screenId)[0];
    }

    async setPermission(userType: string) {
        let perms: RolePermissionDc = new RolePermissionDc();
        // perms.UserType = SessionHelper.getUserType();
        perms.UserType = userType;
        this.init(perms);
    }

    public isValidUrl(userType: string): boolean {
        let permission = this.getRolePermission(userType);
        return permission.UserType === userType;
    }

    public isValidPortalAccess(currentUrl: string, portalAccess: number): boolean {
        if (portalAccess == CustomerPortalAcessEnum.ResourceOnly) {
            let allowedUrls = new Array<string>('cards-loans', 'flagged-accounts', 'program', 'invoice', 'faq', 'referfriend', 'myaccount');
            return allowedUrls.findIndex(s => s == currentUrl) == -1;
        }
        else if (portalAccess == CustomerPortalAcessEnum.PortalOff) {
            return false;
        }
        else if (portalAccess == CustomerPortalAcessEnum.PortalOn) {
            return true;
        }
        else {
            return true;
        }
    }

    public navigationBasedOnUserType(userType: string) {
        let permission = this.getRolePermission(userType);
        if (permission.UserType == UserTypeConstant.Employee || permission.UserType == UserTypeConstant.Admin) {
            this.router.navigate(['/home/crm']);
        }
        else if (permission.UserType == UserTypeConstant.Customer) {
            this.previousURL = '/auth/login';
            this.router.navigate(['/home/customer']);
        }
        else if (permission.UserType == UserTypeConstant.Affiliate) {
            this.router.navigate(['/home/affiliate']);
        }
        else {
            SessionHelper.clearSession();
            this.router.navigateByUrl('/auth/login');
        }
    }

    // API function for getting user role Id
    public getUserRolePermissions(roleId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "permission/getallpermissionsbyroleid/" + roleId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    // API function for adding permission by user role
    public addRolePermissions(rolePermissions: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "permission/addpermissions";
        return this._httpHelper.post(environment.APIBaseUrl + url, rolePermissions, reqOption);
    }

    //API function for getting module access permissions
    public getModuleAccessPermissions(roleId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "permission/getparentmodules/" + roleId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public setModuleAccessPermissions(permissions) {
        //localStorage.setItem('ModulePermissions', JSON.stringify(permissions));
        this.moduleAccessPermission = permissions;
        let encryptedPermissions = CryptoJS.AES.encrypt(JSON.stringify(permissions), this.encryptSecretKey).toString();
        localStorage.setItem('ModulePermissions', encryptedPermissions);
    }

    public getLoaclModulePermissions() {
        let permissions = localStorage.getItem('ModulePermissions') ? localStorage.getItem('ModulePermissions') : false;
        if (permissions) {
            const bytes = CryptoJS.AES.decrypt(permissions, this.encryptSecretKey);
            if (bytes.toString()) {
                return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            }
        }
        return permissions;
    }


    public setUserAccessPermissions(permissions) {
        //localStorage.setItem('ModulePermissions', JSON.stringify(permissions));
        this.moduleAccessPermission = permissions;
        let encryptedPermissions = CryptoJS.AES.encrypt(JSON.stringify(permissions), this.encryptSecretKey).toString();
        localStorage.setItem('UserModulePermissions', encryptedPermissions);
    }

    public getUserModulePermissions() {
        let permissions = localStorage.getItem('UserModulePermissions') ? localStorage.getItem('UserModulePermissions') : false;
        if (permissions) {
            const bytes = CryptoJS.AES.decrypt(permissions, this.encryptSecretKey);
            if (bytes.toString()) {
                return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            }
        }
        return permissions;
    }

    //API function to get specific module permissions by role id
    public getModulePermissions(roleId: Number, moduleName: String) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `permission/getsubmodules?roleId=${roleId}&moduleName=${moduleName}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public updatedCurrentURL(url: string) {
        this.urlSource.next(url);
    }

}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/security/permission.service.ts